/* eslint-disable */

//routeMap
var line;
var lines = [];

var lineCoordinates = [];
var marker;
var markers = [];

var map;
var lineSymbol = {
	path: google.maps.SymbolPath.FORWARD_OPEN_ARROW
};
var activeRoutes = true;
var activeCodeSharRoutes = true;
var startPoint;


var MapMarkerIcon = {
	url: themeURL + '/images/circle.svg', // url

	anchor: new google.maps.Point(10, 10),
	scaledSize: new google.maps.Size(18, 18),
	labelOrigin: new google.maps.Point(10, 30),

};

var CenteresMapMarkerIcon = {
	url: themeURL + '/images/Circle-Centered.svg', // url

	anchor: new google.maps.Point(10, 10),
	scaledSize: new google.maps.Size(18, 18),
	labelOrigin: new google.maps.Point(10, 30),

};
var planeSymbol = {
	path1: 'M22.1,15.1c0,0-1.4-1.3-3-3l0-1.9c0-0.2-0.2-0.4-0.4-0.4l-0.5,0c-0.2,0-0.4,0.2-0.4,0.4l0,0.7c-0.5-0.5-1.1-1.1-1.6-1.6l0-1.5c0-0.2-0.2-0.4-0.4-0.4l-0.4,0c-0.2,0-0.4,0.2-0.4,0.4l0,0.3c-1-0.9-1.8-1.7-2-1.9c-0.3-0.2-0.5-0.3-0.6-0.4l-0.3-3.8c0-0.2-0.3-0.9-1.1-0.9c-0.8,0-1.1,0.8-1.1,0.9L9.7,6.1C9.5,6.2,9.4,6.3,9.2,6.4c-0.3,0.2-1,0.9-2,1.9l0-0.3c0-0.2-0.2-0.4-0.4-0.4l-0.4,0C6.2,7.5,6,7.7,6,7.9l0,1.5c-0.5,0.5-1.1,1-1.6,1.6l0-0.7c0-0.2-0.2-0.4-0.4-0.4l-0.5,0c-0.2,0-0.4,0.2-0.4,0.4l0,1.9c-1.7,1.6-3,3-3,3c0,0.1,0,1.2,0,1.2s0.2,0.4,0.5,0.4s4.6-4.4,7.8-4.7c0.7,0,1.1-0.1,1.4,0l0.3,5.8l-2.5,2.2c0,0-0.2,1.1,0,1.1c0.2,0.1,0.6,0,0.7-0.2c0.1-0.2,0.6-0.2,1.4-0.4c0.2,0,0.4-0.1,0.5-0.2c0.1,0.2,0.2,0.4,0.7,0.4c0.5,0,0.6-0.2,0.7-0.4c0.1,0.1,0.3,0.1,0.5,0.2c0.8,0.2,1.3,0.2,1.4,0.4c0.1,0.2,0.6,0.3,0.7,0.2c0.2-0.1,0-1.1,0-1.1l-2.5-2.2l0.3-5.7c0.3-0.3,0.7-0.1,1.6-0.1c3.3,0.3,7.6,4.7,7.8,4.7c0.3,0,0.5-0.4,0.5-0.4S22,15.3,22.1,15.1z',
	pathram: 'M 20.074,21.459 L 17.531,21.596 L 11.284,27.298 L 4.345,27.669 C 3.01,27.741 1.227,27.902 1.28,28.881 C 1.331,29.851 3.857,30.95 5.504,30.861 L 20.543,30.055 L 24.556,34.735 L 26.248,34.644 L 24.524,29.056 C 25.126,28.774 25.597,28.438 25.575,28.062 C 25.52,27.008 22.161,26.715 19.864,26.837 L 18.258,26.924 L 18.263,27.023 L 19.869,26.936 C 22.242,26.81 25.427,27.141 25.476,28.067 C 25.493,28.372 25.084,28.691 24.443,28.984 L 24.403,29.002 L 26.115,34.551 L 24.599,34.632 L 20.586,29.952 L 5.499,30.762 C 3.842,30.851 1.426,29.742 1.379,28.876 C 1.334,28.023 2.941,27.844 4.35,27.768 L 11.325,27.395 L 17.572,21.693 L 19.873,21.57 L 16.931,25.741 L 15.96,27.751 L 16.051,27.794 L 17.018,25.792 L 20.074,21.459 Z M 17.487,31.814 L 17.41,31.879 L 19.065,33.856 L 17.041,33.965 L 13.727,32.004 L 13.676,32.091 L 17.016,34.066 L 19.27,33.945 L 17.487,31.814 Z',
	path: 'M23.43,13.52l0,0.83H22l0-1.17l-6.22-1.48l-0.05,0.7c-0.18,2.59-0.46,4.76-0.82,6.27l-0.1,0.41l3.61,2.34  l0,0.98l-3.52-1.28l-0.85,0.71l-0.81-0.74L9.65,22.4v-0.98l3.54-2.3l-0.09-0.4c-0.33-1.46-0.58-3.58-0.75-6.32l-0.04-0.71  l-6.24,1.49l0,1.17H4.64l0-0.83L0,14.62v-1.6l4.64-2.41l0-1.96c0-0.12,0.1-0.39,0.31-0.61c0.08-0.08,0.23-0.21,0.4-0.21  c0.34,0,0.72,0.53,0.72,0.82l0,1.22l6.08-3.16l-0.01-0.37c-0.01-0.35-0.01-1.11-0.01-1.73l-0.01-0.76  c-0.01-1.03,0.56-2.75,1.34-3.53C13.6,0.17,13.82,0,14.03,0c0.83,0,1.9,2.39,1.91,3.86c0,0.54,0,1.97,0,2.5l0,0.36L22,9.87V8.65  c0-0.12,0.1-0.39,0.31-0.61c0.08-0.08,0.23-0.21,0.4-0.21c0.15,0,0.32,0.11,0.47,0.28c0.16,0.19,0.25,0.41,0.25,0.53l0,1.96  l4.64,2.41l0,1.6L23.43,13.52z',
	// fillColor: '#3b0e61',
	fillColor: 'whitesmoke',
	// fillColor: '#3b0e61',
	strokeColor: '#3b0e61',
	fillOpacity: 1,
	scale: .9,

	anchor: new google.maps.Point(14, 10),
	// anchor: new google.maps.Point(28.07, 22.4),


	// strokeWeight: 1.014
	strokeWeight: 1.5
};


var pixelOffsetY =7;
var infowindow = new google.maps.InfoWindow({
	// pixelOffset: new google.maps.Size(0, 0)
	pixelOffset: new google.maps.Size(0, pixelOffsetY)
});




function initialize() {


	map = new google.maps.Map(document.getElementById("mapCanvas"), mapOptions);



	if (typeof fullscreenControl !== "undefined" && fullscreenControl) {
		var mapDiv = document.getElementById('mapCanvas').getElementsByTagName('div')[0];
		mapDiv.appendChild(document.getElementById("mapControl"));
	}



	google.maps.event.addListener(map, 'zoom_changed', function () {


		var zoom = map.getZoom();

		if (zoom >= ZoomToShowLabels) {
			$('.mapCanvas').addClass('showMapMarkerIcon');

		} else {

			$('.mapCanvas').removeClass('showMapMarkerIcon');

		}


	});



} //end initialize

let currentZIndex = 0;

function setMapOnAll(map) {
	for (let i = 0; i < markers.length; i++) {
		markers[i].setMap(map);

	}
}

function setmaplines(map) {
	for (var i = 0; i < lines.length; i++) {

		lines[i].setMap(map);
	}
}

let airportMarker;
let allMarkersArray = [];

function addMarkerClickEvent(content, flightStateClr) {

}
let markerclickedFromList = false;

function initSlectedLines() {
	markers = [];
	airportMarker = [];
	allMarkersArray = [];
	let clicked = false;
	let MarkerIcon = MapMarkerIcon;
	var highestZIndex = 0;


	var marker;



	for (var i = 0; i < lineCoordinates.length; i++) {


		if (i == 0) {
			MarkerIcon = CenteresMapMarkerIcon;
		} else {
			MarkerIcon = MapMarkerIcon;

		}
		marker = new google.maps.Marker({
			position: lineCoordinates[i][0],
			map: map,
			icon: MarkerIcon,
			index: i,
			label: {
				text: lineCoordinates[i][3],
				color: "#000",
				// fontSize: "16px",
				// fontWeight: "bold",
				className: 'MapMarkerLabel'
			}
		});
		markers.push(marker)
		//








		infowindowOnHover = new google.maps.InfoWindow({
			content: `<div class="hoverPopup">${lineCoordinates[i][1]} </div>`,
			 pixelOffset: new google.maps.Size(0, pixelOffsetY)

		});



		(function (infowindowOnHover) {

			google.maps.event.addListener(marker, 'mouseover', function () {


				let zoooooomed = currentZIndex + 100;
				infowindowOnHover.setZIndex(zoooooomed);
				infowindowOnHover.open(map, this);



			});

			google.maps.event.addListener(marker, 'mouseout', function () {
				infowindowOnHover.close();

			});
		})(infowindowOnHover);



		airportMarker = markers[i];
		var content = lineCoordinates[i][1];



		if (i != 0) {
			let flightStateClr = 'rgba(61 ,16, 99,.5)';
			// if codeShare
			if (lineCoordinates[i][2] == 'true') {
				flightStateClr = 'rgb(245 ,130, 32,.5)';
			}
			//addMarkerClickEvent(content ,flightStateClr);






			// for clicking on markers
			google.maps.event.addListener(airportMarker, 'click', (function (airportMarker, content, infowindow, index) {
				return function () {
					clicked = true;
					setmaplines(null);

					//lineCoordinates = [];
					lines = [];
					setmaplines(null);





					//select airport in list if the click not from the listitself
					if (!markerclickedFromList) {
						window.initSelectedAirportOnlIst((this.index) - 1);

					}
					markerclickedFromList = false;
					//map.setZoom(myzoom + 3);
					map.panTo(this.position);


					line = new google.maps.Polyline({
						path: [startPoint[0], this.position],
						strokeOpacity: 1,
						strokeWeight: 2,
						strokeColor: flightStateClr,
						geodesic: true,

						icons: [{
							icon: planeSymbol,
							offset: '0%',

						}]
					});

					lines.push(line);



					animate(line, 10);
					setmaplines(map);

					infowindow.setContent(content);
					infowindow.open(map, airportMarker);
					currentZIndex = infowindow.getZIndex();

					console.log('currentZIndex', currentZIndex)

				};
			})(airportMarker, content, infowindow));
			if (!markerclickedFromList) {

				allMarkersArray.push(airportMarker);
			}
			// end marker click



		}







	} //end for
	//for first init only




	if (activeRoutes)
		setmaplines(map);


}

//for markers delegate click when select from list airport
window.clickMapMarker = function (index) {
	markerclickedFromList = true;
	google.maps.event.trigger(allMarkersArray[index], 'click');
}




function animate(line, k) {
	// var count = 0;


	var count = 50;
	let offsetId = window.setInterval(function () {
		// count = (count + 1) % 2000;
		count = (count + 1) % 200;

		const icons = line.get("icons");

		icons[0].offset = count / 2 + "%";
		line.set("icons", icons);
	}, 50);
}



initialize();





window.initSelectedAirport = function (selectedValue) {

	let selectedDesTo;

	setmaplines(null);
	setMapOnAll(null);

	lineCoordinates = [];
	lines = [];

	selectedDesTo = airportList.filter(res => {
		return selectedValue === res.value
	})


	startPoint = [new google.maps.LatLng(selectedDesTo[0].lat, selectedDesTo[0].lng, selectedDesTo[0].city)];

	//push the startFrom Point

	lineCoordinates.push([startPoint[0], selectedDesTo[0].Info, false, selectedDesTo[0].city]);
	let desList = selectedDesTo[0].destinations;

	for (var i = 0; i < desList.length; i++) {

		var loc = new google.maps.LatLng(desList[i].lat, desList[i].lng);

		lineCoordinates.push([loc, desList[i].Info, desList[i].codeShare, desList[i].city]);


	}
	initSlectedLines();
	map.panTo(startPoint[0])
}





if (typeof firstOpen !== "undefined") {
	setTimeout(function () {
		window.initSelectedAirport(firstOpen);
		window.initSelectedDepartureInstancesAirportOnlIst(firstOpenIndex);


	}, 500)



}






//reset map
$("body").delegate(".resetRouteMap", "click", function () {
	map.setZoom(myzoom);
	map.setCenter(myLatlng);
	window.initSelectedAirport(firstOpen);

	$("#DepartureTo-0").val('');
	$("#DepartureTo-0").parent().parent().find('.floatingLabel').removeClass('active');

	$("#DepartureFrom-0").val('');
	$("#DepartureFrom-0").parent().parent().find('.floatingLabel').addClass('active');

	$('.routeMapInputSearch').val(firstOpen);
	//$("#DepartureFrom-0").val(firstOpen);



	window.initSelectedDepartureInstancesAirportOnlIst(firstOpenIndex);


});




$("body").delegate(".book-flight-form-map", "click", function () {
	let flightVal = $(this).attr('flight-val');
	$("#DepartureTo-0").val(flightVal);
	$("#DepartureTo-0").parent().parent().find('.floatingLabel').addClass('active');
	$("html,body").animate({
		scrollTop: $('.bookingForms').offset().top - 130

	}, 300)

})


//end routeMapInputSearch
